"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewContentCommand = void 0;
const AbstractCommand_1 = require("./AbstractCommand");
class ViewContentCommand extends AbstractCommand_1.AbstractCommand {
    constructor(input) {
        super(input);
        this.input = input;
    }
    async execute(config) {
        return this.getCommandService(config).doTrackViewContentEvent(this.input);
    }
}
exports.ViewContentCommand = ViewContentCommand;
